export { Statistic, StatisticProps } from './Statistic';
